import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'objectFilter'
})
export class ObjectFilterPipe implements PipeTransform {

    transform(value: any, args: any): any {

        let filter = args;

        if (filter && Array.isArray(value)) {
            let filterKeys = Object.keys(filter);
            return value.filter(item =>
                filterKeys.some((keyName) =>
                    item[keyName] && (item[keyName] + '').toLowerCase().indexOf(filter[keyName].toLowerCase()) > -1));
        } else {
            return value;
        }
    }
}
